import { hopintoReducerKey } from './HopintoConstants';

export function hopinto(state) {
  return state.get(hopintoReducerKey);
}

export function fullTextDocumentId(state) {
  return hopinto(state).get('fullTextDocumentId');
}
